export default import.meta.ROLLDOWN_FILE_URL_WCQlC7GAMhg6nCwnx5Q_$A